import app from './ui.js';
import Core from './core.ts';
import Cmd from './model/cmds.ts';
import I18n from './i18n.ts';
import Theme from './theme.js';
import Keys from './keys.ts';

app.init();

// Zugriff für Fehlersuche und Browser-Tests (Konsole: __xf.app, __xf.Core, …)
window.__xf = { app, Core, Cmd, I18n, Theme, Keys };
